/*@flow*/

export default (prefix: string): ((v: string, k: string) => null | RegExp$matchResult) => (v: string, k: string) =>
  k.match(new RegExp(`^${prefix}`));
